import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  GenericWrapper, Mt2, FlexCenterWrapper, Mr2, Width500, FlexCenterBetweenWrapper, Mt5,
  BorderBottomWrapper, Pb4, Mt10, TooltipWrapper
} from 'wrappers';
import { SecondaryTextLgBold, Text, SecondaryTextSm, PriorityColumns, Tooltip, Empty } from 'atoms';
import { IconTextButton } from 'molecules';
import { QuestionMarkSvg, PlusSignSvg } from 'components/icons';

export const definition = {
  name: 'PrioritiesSettings',
  controller: Controller,
  initialProps: ({ priorities }) => ({ priorities }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'TitleWrapper',
      elements: [
        {
          component: wrap(SecondaryTextLgBold, Mr2),
          name: 'Title',
          displayValue: () => 'Work Order Priority'
        },
        {
          wrapper: TooltipWrapper,
          name: 'Info',
          elements: [
            {
              component: Empty,
              name: 'Icon',
              displayValue: ({ }) => QuestionMarkSvg({ width: 15, height: 15 })
            },
            {
              component: Tooltip,
              name: 'Popup',
              displayState: ({ }) => ({ width: '228px', direction: 'bottom', offset: 'start', textAlign: 'unset' }),
              displayValue: ({ }) => 'The order of priorities determines the order of the tasks in both the Admin Portal and Technician App when sorted by priority.'
            }
          ]
        },
      ]
    },
    {
      component: wrap(Text, Mt2),
      name: 'Description',
      displayValue: () => 'Add, edit, delete and discontinue work order priorities',
    },
    {
      wrapper: Width500,
      name: '__transparent__',
      elements: [
        {
          wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Mt5), Pb4), BorderBottomWrapper),
          name: 'HighPriority',
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'TitleWrapper',
              elements: [
                {
                  component: wrap(SecondaryTextSm, Mr2),
                  name: 'Title',
                  displayValue: ({ }) => 'High Priority'
                },
                {
                  wrapper: TooltipWrapper,
                  name: 'Info',
                  elements: [
                    {
                      component: Empty,
                      name: 'Icon',
                      displayValue: ({ }) => QuestionMarkSvg({ width: 15, height: 15 })
                    },
                    {
                      component: Tooltip,
                      name: 'Popup',
                      displayState: ({ }) => ({ width: '228px', direction: 'bottom', offset: 'start', textAlign: 'unset' }),
                      displayValue: ({ }) => 
                      `• Email will be sent to admins subscribed to High Priority Work Order Email when a high priority work order is created \n• High priority work orders are noted in reports \n• Higher priority given for these work orders in Auto Assign`
                    }
                  ]
                },
              ]
            },
            {
              component: IconTextButton,
              name: 'Create',
              bindings: ({ priorities }) => ({ priorities, title: 'Add High Priority', icon: PlusSignSvg({}) })
            },
          ]
        },
        {
          component: PriorityColumns,
          name: 'HighPriorities',
          displayValue: ({ priorities }) => {
            const _onChange = ({ handle }, o) => handle(o)
            return {
              allPriorities: priorities,
              priorities: priorities?.filter(p => p.is_high_priority) ?? [],
              _onChange,
              onChangeField: 'onChange'
            }
          }
        },
        {
          wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Mt10), Pb4), BorderBottomWrapper),
          name: 'StandardPriority',
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'TitleWrapper',
              elements: [
                {
                  component: wrap(SecondaryTextSm, Mr2),
                  name: 'Title',
                  displayValue: ({ }) => 'Standard Priority'
                },

                {
                  wrapper: TooltipWrapper,
                  name: 'Info',
                  elements: [
                    {
                      component: Empty,
                      name: 'Icon',
                      displayValue: ({ }) => QuestionMarkSvg({ width: 15, height: 15 })
                    },
                    {
                      component: Tooltip,
                      name: 'Popup',
                      displayState: ({ }) => ({ width: '228px', direction: 'bottom', offset: 'start', textAlign: 'unset' }),
                      displayValue: ({ }) => `Standard priority work orders are given no special priority handling, but can still be sorted by priority (based on order in the list below) in the Admin Portal and the Tech App.`
                    }
                  ]
                },
              ]
            },
            {
              component: IconTextButton,
              name: 'Create',
              bindings: ({ priorities }) => ({ priorities, title: 'Add Standard Priority', icon: PlusSignSvg({}) })
            },
          ]
        },
        {
          component: PriorityColumns,
          name: 'StandardPriorities',
          displayValue: ({ priorities }) => {
            const _onChange = ({ handle }, o) => handle(o)
            return {
              allPriorities: priorities,
              priorities: priorities?.filter(p => !p.is_high_priority) ?? [],
              _onChange,
              onChangeField: 'onChange'
            }
          }
        },
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), GenericWrapper);